var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldSecurityCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 13.379c-.3 0-.54.24-.54.54 0 .3.24.54.54.54h2.49c.3 0 .54-.24.54-.54 0-.3-.24-.54-.54-.54H11zM8.188 13.379c-.3 0-.54.24-.54.54 0 .3.24.54.54.54h1.25c.3 0 .54-.24.54-.54 0-.3-.24-.54-.54-.54h-1.25z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.04 2.161c-.57-.21-1.5-.21-2.07 0l-5.5 2.06c-1.06.4-1.92 1.64-1.92 2.77v8.1c0 .81.53 1.88 1.18 2.36l5.5 4.11c.97.73 2.56.73 3.53 0l5.5-4.11c.65-.49 1.18-1.55 1.18-2.36v-8.1c.01-1.13-.85-2.37-1.9-2.77l-5.5-2.06zm2.39 14.08H8.58c-2.19 0-2.74-.54-2.74-2.71v-2.33c0-.28.22-.5.5-.5h11.33c.28 0 .5.22.5.5v2.45c-.02 2.07-.59 2.59-2.74 2.59zm2.24-6.63H6.34c-.28 0-.5-.22-.5-.5v-.64c0-1.96.46-2.59 2.17-2.7.18 0 .37-.01.57-.01h6.85c2.19 0 2.74.54 2.74 2.71v.64c0 .28-.22.5-.5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSecurityCard);
export default __webpack_public_path__ + "static/media/vuesax-bold-security-card.344e666fba0dddbcc776ecd1d1c7537f.svg";
export { ForwardRef as ReactComponent };